
function getScopedSlots(scopedSlots, item, h) {
  const tmp = {}
  if (scopedSlots[item.prop]) {
    tmp.default = scopedSlots[item.prop]
  }
  if (item.customRenderCell) {
    tmp.default = item.customRenderCell
  }
  if (item.editCell) {
    tmp.default = function (props) {
      const prop = props.column.property
      return h('edit-cell', {
        props: {
          params: props.row,
          value: props.row[prop]
        },
        on: {
          blur: item.blur,
          input: (val) => (props.row[prop] = val)
        }
      })
    }
  }
  if (item.slotName) {
    tmp.default = scopedSlots[item.slotName]
  }
  const slotHeaderName = item.slotHeaderName || (item.prop + 'Header')

  if (scopedSlots[slotHeaderName]) {
    tmp.header = scopedSlots[slotHeaderName]
  }
  return tmp
}

function getRenderItem(h, item, context) {
  const children = (item.children || []).map(i => getRenderItem(h, i, context))
  const scopedSlots = getScopedSlots(context.data.scopedSlots, item, h)
  if (item.label && (!item.width && !item.minWidth) || (item.minWidth && parseInt(item.minWidth) < item.label.length * 13)) {
    item.minWidth = item.label.length * 13
  }
  if (item.label && item.width && parseInt(item.width) < item.label.length * 13) {
    item.width = item.label.length * 13
  }
  return h('el-table-column', {
    props: item,
    attrs: item,
    scopedSlots,
  }, children)
}
export default {
  functional: true,
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  render(h, context) {
    const {
      props
    } = context
    const { item } = props
    return getRenderItem(h, item, context)
  }
}
